import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { getChildByKey } from '../../../shared/helpers/functions/markup';

export default function PlanDescription({
  children,
}: {
  children: ReactNode[];
}) {
  return (
    <Box
      sx={{
        minHeight: {
          sm: '205px',
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: {
          xs: '20px',
          sm: '12px',
        },
      }}
    >
      <Box>
        <Typography
          variant="h2"
          sx={{
            mb: '12px',
          }}
        >
          {getChildByKey(children, 'title')}
        </Typography>
        <Typography component="p" variant="body1">
          {getChildByKey(children, 'description')}
        </Typography>
      </Box>
      {getChildByKey(children, 'price')}
    </Box>
  );
}
